import React from "react";
import { useQuickSightCosts } from "@/hooks/useMonthlyCostsReports";

const QuickSightAwsCostsDashboard = () => {
  const { embedUrl } = useQuickSightCosts();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsCostsDashboard;
